const store = {
    namespaced: true,
    state: {
        'availableLanguages': [],
        'currencies': [],
        'errorsHandler' : {},
        'globalLoading' : false
    },
    mutations: {
        toggleLoading(state) {
            state['globalLoading'] = !state['globalLoading']
        },
        startLoading(state) {
            state['globalLoading'] = true
        },
        stopLoading(state) {
            state['globalLoading'] = false
        },
    },
    actions: {
        toggleLoading({ commit }) {
            commit('toggleLoading')
        },
        startLoading({ commit }) {
            commit('startLoading')
        },
        stopLoading({ commit }) {
            commit('stopLoading')
        },
    },
};

const factory = (system = {}) => {
    return {
        ...store,
        state: {
            'availableLanguages': system.availableLanguages,
            'currencies': system.currencies,
            'errorsHandler' : system.errorsHandler,
            'reCaptchav3' : system.reCaptchav3,
            'globalLoading': false
        },
    };
};

export { store as default, factory }